
import React from 'react';
import { Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';

interface Props {
  message: string;
}

const MyTooltip: React.FC<Props> = ({ message }) => {
  return (
    <Tooltip title={message}>
      <IconButton>
        <VisibilityIcon />
      </IconButton>
    </Tooltip>
  );
};

export default MyTooltip;
